import { render, staticRenderFns } from "./lp-cell.vue?vue&type=template&id=39a48329&"
import script from "./lp-cell.vue?vue&type=script&lang=js&"
export * from "./lp-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports